import Vue from "vue";

export default {
  data() {
    return {
      FieldFlags: {
        Individual: {
          AccountAccountType: true,
          AccountAccountStatus: true,
          AccountEmailAddress: true,
          AccountEmailAddressConfirm: true,
          AccountPassword: true,
          AccountPasswordConfirm: true,
          AccountHasNpiNumber: true,
          AccountNpiNumber: true,
          AccountLicenseNumber: true,
          AccountState: true,
          AccountPrimaryContact: true,
          AccountEyeDoctors: true,
          AccountId: true,
          AccountValidationResult: true,
          ContactFirstName: true,
          ContactLastName: true,
          ContactSuffix: true,
          ContactPhoneNumber: true,
          ContactYearsInPractice: true,
          ContactLegalName: false,
          ContactBusinessType: true,
          ContactIsMultiLocation: false,
          ContactRole: false,
          ContactOfficeLocation: true,
          ContactAccountType: true,
          ContactId: true,
          ContactValidationResult: true,
          EyeDoctorInformation: false,
          InviteDoctor: false,
          NonProfitOrganizationDetails: false,
          OfficeLocationName: false,
          OfficeLocationStreetAddress: true,
          OfficeLocationSuite: true,
          OfficeLocationCity: true,
          OfficeLocationState: true,
          OfficeLocationZip: true,
          OfficeLocationPhoneNumber: false,
          OfficeLocationEmailAddress: false,
          OfficeLocationContactFirstName: false,
          OfficeLocationContactLastName: false,
          OfficeLocationContactRole: false,
          OfficeLocationNumberOfJobs: true,
          OfficeLocationAccountType: true,
          OfficeLocationIsMultiLocation: true,
          OfficeLocationId: true,
          OfficeLocationValidationResult: true,
          EyeDoctorNpiNumber: false,
          EyeDoctorUseLicenseNumber: false,
          EyeDoctorLicenseNumber: false,
          EyeDoctorState: false,
          EyeDoctorFirstName: false,
          EyeDoctorLastName: false,
          EyeDoctorSuffix: false,
          EyeDoctorEmailAddress: false,
          EyeDoctorYearsInPractice: false,
          EyeDoctorAccountType: true,
          EyeDoctorId: true,
          EyeDoctorValidationResult: true,
          IndividualLabels: true,
          BusinessLabels: false,
          NonProfitLabels: false,
          IndividualOrganization: true,
          BusinessOrganization: false,
          NonProfitOrganization: false,
          BusinessTypeIndividual: true,
          BusinessTypeBusiness: false,
          BusinessTypeNonProfit: false,
          RoleBusiness: false,
          RoleNonProfit: false,
          OfficeLocationContact: false,
          EyeDoctorName: false,
          EyeDoctorEmail: false,
          AddEyeDoctor: false,
          MultipleDoctor: false,
          Associations: false,
          ProfessionalInfo: true,
          BusinessPrimaryContact: false,
          NonprofitPrimaryContact: false,
          IndividualNpiNumber: false,
          IndividualNpiNumberField: false,
          ParticipantAccountNpiNumber: false,
          BusinessNonProfitFormGroup: true,
          PrimaryContactChecked: false,
          LicenseNumber: false
        },
        Business: {
          AccountAccountType: true,
          AccountAccountStatus: true,
          AccountEmailAddress: true,
          AccountEmailAddressConfirm: true,
          AccountPassword: true,
          AccountPasswordConfirm: true,
          AccountHasNpiNumber: false,
          AccountNpiNumber: false,
          AccountLicenseNumber: false,
          AccountState: false,
          AccountPrimaryContact: true,
          AccountEyeDoctors: true,
          AccountId: true,
          AccountValidationResult: true,
          ContactFirstName: true,
          ContactLastName: true,
          ContactSuffix: true,
          ContactPhoneNumber: true,
          ContactYearsInPractice: false,
          ContactLegalName: true,
          ContactBusinessType: true,
          ContactIsMultiLocation: true,
          ContactRole: true,
          ContactOfficeLocation: true,
          ContactAccountType: true,
          ContactId: true,
          ContactValidationResult: true,
          EyeDoctorInformation: true,
          InviteDoctor: true,
          NonProfitOrganizationDetails: false,
          OfficeLocationName: true,
          OfficeLocationStreetAddress: true,
          OfficeLocationSuite: true,
          OfficeLocationCity: true,
          OfficeLocationState: true,
          OfficeLocationZip: true,
          OfficeLocationPhoneNumber: true,
          OfficeLocationEmailAddress: true,
          OfficeLocationContactFirstName: true,
          OfficeLocationContactLastName: true,
          OfficeLocationContactRole: true,
          OfficeLocationNumberOfJobs: true,
          OfficeLocationAccountType: true,
          OfficeLocationIsMultiLocation: true,
          OfficeLocationId: true,
          OfficeLocationValidationResult: true,
          EyeDoctorNpiNumber: true,
          EyeDoctorUseLicenseNumber: true,
          EyeDoctorLicenseNumber: true,
          EyeDoctorState: true,
          EyeDoctorFirstName: true,
          EyeDoctorLastName: true,
          EyeDoctorSuffix: true,
          EyeDoctorEmailAddress: true,
          EyeDoctorYearsInPractice: true,
          EyeDoctorAccountType: true,
          EyeDoctorId: true,
          EyeDoctorValidationResult: true,
          IndividualLabels: false,
          BusinessLabels: true,
          NonProfitLabels: false,
          IndividualOrganization: false,
          BusinessOrganization: true,
          NonProfitOrganization: false,
          BusinessTypeIndividual: false,
          BusinessTypeBusiness: true,
          BusinessTypeNonProfit: false,
          RoleBusiness: true,
          RoleNonProfit: false,
          OfficeLocationContact: true,
          EyeDoctorName: true,
          EyeDoctorEmail: true,
          AddEyeDoctor: true,
          MultipleDoctor: true,
          Associations: true,
          ProfessionalInfo: false,
          BusinessPrimaryContact: true,
          NonprofitPrimaryContact: false,
          BusinessAccountNpiNumber: true,
          IndividualNpiNumber: true,
          IndividualNpiNumberField: true,
          ParticipantAccountNpiNumber: true,
          BusinessNonProfitFormGroup: false,
          PrimaryContactChecked: true,
          LicenseNumber: true
        },

        NonProfit: {
          AccountAccountType: true,
          AccountAccountStatus: true,
          AccountEmailAddress: true,
          AccountEmailAddressConfirm: true,
          AccountPassword: true,
          AccountPasswordConfirm: true,
          AccountHasNpiNumber: false,
          AccountNpiNumber: false,
          AccountLicenseNumber: false,
          AccountState: false,
          AccountPrimaryContact: true,
          AccountEyeDoctors: true,
          AccountId: true,
          AccountValidationResult: true,
          ContactFirstName: true,
          ContactLastName: true,
          ContactSuffix: true,
          ContactPhoneNumber: true,
          ContactYearsInPractice: false,
          ContactLegalName: true,
          ContactBusinessType: true,
          ContactIsMultiLocation: true,
          ContactRole: true,
          ContactOfficeLocation: true,
          ContactAccountType: true,
          ContactId: true,
          ContactValidationResult: true,
          EyeDoctorInformation: true,
          InviteDoctor: true,
          NonProfitOrganizationDetails: true,
          OfficeLocationName: true,
          OfficeLocationStreetAddress: true,
          OfficeLocationSuite: true,
          OfficeLocationCity: true,
          OfficeLocationState: true,
          OfficeLocationZip: true,
          OfficeLocationPhoneNumber: true,
          OfficeLocationEmailAddress: true,
          OfficeLocationContactFirstName: true,
          OfficeLocationContactLastName: true,
          OfficeLocationContactRole: true,
          OfficeLocationNumberOfJobs: true,
          OfficeLocationAccountType: true,
          OfficeLocationIsMultiLocation: true,
          OfficeLocationId: true,
          OfficeLocationValidationResult: true,
          EyeDoctorNpiNumber: true,
          EyeDoctorUseLicenseNumber: true,
          EyeDoctorLicenseNumber: true,
          EyeDoctorState: true,
          EyeDoctorFirstName: true,
          EyeDoctorLastName: true,
          EyeDoctorSuffix: true,
          EyeDoctorEmailAddress: true,
          EyeDoctorYearsInPractice: true,
          EyeDoctorAccountType: true,
          EyeDoctorId: true,
          EyeDoctorValidationResult: true,
          IndividualLabels: false,
          BusinessLabels: false,
          NonProfitLabels: true,
          IndividualOrganization: false,
          BusinessOrganization: false,
          NonProfitOrganization: true,
          BusinessTypeIndividual: false,
          BusinessTypeBusiness: false,
          BusinessTypeNonProfit: true,
          RoleBusiness: false,
          RoleNonProfit: true,
          OfficeLocationContact: true,
          EyeDoctorName: true,
          EyeDoctorEmail: true,
          AddEyeDoctor: true,
          MultipleDoctor: true,
          Associations: false,
          ProfessionalInfo: false,
          BusinessPrimaryContact: true,
          NonprofitPrimaryContact: true,
          AccountIndividualNpiNumber: true,
          IndividualNpiNumber: true,
          IndividualNpiNumberField: false,
          ParticipantAccountNpiNumber: true,
          BusinessNonProfitFormGroup: false,
          PrimaryContactChecked: true,
          PrimaryContactChecked: true,
          LicenseNumber: true
        },
        LoginInformation: {
          EmailAddress: true,
          EmailAddressConfirm: true,
          Password: true,
          NewPassword: true,
          NewPasswordConfirm: true,
          ValidationResult: true,
          ErrorMessage: true
        }
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/mixins/FormType.js